export const LastViewKey = "last"